import React, { useEffect, useCallback } from 'react';
import './PolicyModal.css';

const PolicyModal = ({ isOpen, onClose, title, content }) => {
  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  const handleKeyDown = useCallback((e) => {
    if (e.key === 'Escape') {
      onClose();
    }
  }, [onClose]);

  useEffect(() => {
    if (isOpen) {
      document.addEventListener('keydown', handleKeyDown);
      document.body.style.overflow = 'hidden';
    }

    return () => {
      document.removeEventListener('keydown', handleKeyDown);
      document.body.style.overflow = 'unset';
    };
  }, [isOpen, handleKeyDown]);

  if (!isOpen) return null;

  return (
    <div className="policy-modal" onClick={handleBackdropClick}>
      <div className="policy-modal__content">
        <div className="policy-modal__header">
          <h2 className="policy-modal__title">{title}</h2>
          <button 
            className="policy-modal__close" 
            onClick={onClose}
            aria-label="Cerrar modal"
          >
            ✕
          </button>
        </div>
        
        <div className="policy-modal__body">
          <div className="policy-modal__text">
            {content}
          </div>
        </div>
        
        <div className="policy-modal__footer">
          <button className="policy-modal__button" onClick={onClose}>
            Entendido
          </button>
        </div>
      </div>
    </div>
  );
};

export default PolicyModal;